import { render } from "./PerformanceReviewView.vue?vue&type=template&id=da6bfd6e"
import script from "./PerformanceReviewView.vue?vue&type=script&lang=js"
export * from "./PerformanceReviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__